export default __webpack_public_path__ + "static/media/Metal007_1K_NormalGL.7633e876.jpg";